<app-value-analysis [showNotes]="true">
  <app-action-icons></app-action-icons>
</app-value-analysis>
